/**
 * Fees Service - API client for fee structures, class assignment,
 * payments, and collection summaries
 */
import api from '../utils/api';

const feesService = {
  getSummary: async () => {
    try {
      return await api.get('/api/fees/summary');
    } catch (error) {
      console.error('Error fetching fee summary:', error);
      throw error;
    }
  },

  listStructures: async () => {
    try {
      return await api.get('/api/fees/structures');
    } catch (error) {
      console.error('Error fetching fee structures:', error);
      throw error;
    }
  },

  createStructure: async (data) => {
    try {
      return await api.post('/api/fees/structures', data);
    } catch (error) {
      console.error('Error creating fee structure:', error);
      throw error;
    }
  },

  getOutstanding: async () => {
    try {
      return await api.get('/api/fees/outstanding');
    } catch (error) {
      console.error('Error fetching outstanding fees:', error);
      throw error;
    }
  },

  getClassFees: async (classId) => {
    try {
      return await api.get(`/api/fees/class/${classId}`);
    } catch (error) {
      console.error('Error fetching class fees:', error);
      throw error;
    }
  },

  recordPayment: async (data) => {
    try {
      return await api.post('/api/fees/payments', data);
    } catch (error) {
      console.error('Error recording fee payment:', error);
      throw error;
    }
  },

  assignToClass: async (structureId, classId) => {
    try {
      return await api.post('/api/fees/assign-class', {
        structure_id: structureId,
        class_id: classId
      });
    } catch (error) {
      console.error('Error assigning fee to class:', error);
      throw error;
    }
  },

  getStudentFees: async (studentId) => {
    try {
      return await api.get(`/api/fees/student/${studentId}`);
    } catch (error) {
      console.error('Error fetching student fees:', error);
      throw error;
    }
  },

  voidPayment: async (paymentId, reason) => {
    try {
      return await api.post(`/api/fees/payments/${paymentId}/void`, { reason });
    } catch (error) {
      console.error('Error voiding payment:', error);
      throw error;
    }
  },

  listInstallments: async (feeId) => {
    try {
      return await api.get(`/api/fees/${feeId}/installments`);
    } catch (error) {
      console.error('Error fetching installment plan:', error);
      throw error;
    }
  },

  createInstallmentPlan: async (feeId, installments) => {
    try {
      return await api.post(`/api/fees/${feeId}/installments`, { installments });
    } catch (error) {
      console.error('Error creating installment plan:', error);
      throw error;
    }
  },

  applyDiscount: async (feeId, data) => {
    try {
      return await api.patch(`/api/fees/${feeId}/discount`, data);
    } catch (error) {
      console.error('Error applying discount:', error);
      throw error;
    }
  }
};

export default feesService;
